import auth from './auth'
// eslint-disable-next-line import/no-cycle
import store from '../../store'

export const setup = (to, from, next) => {
  if (!to.meta.middleware) {
    return next()
  }
  const { middleware } = to.meta
  const context = {
    to,
    from,
    next,
    store
  }
  return middleware[0]({
    ...context
  })
}

/**
 * Exports all the middleware function to be consumed by vue router
 */
export default { auth, setup }
